import moment from 'moment';
import { humanize } from 'underscore.string';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Translation, withTranslation } from 'react-i18next';

import formatMoney from 'utils/formatters/Money';
import { getCircleButtonClass } from '../../../v2/buttons/CircleButton';
import DownloadIcon from '../../../v2/icons/DownloadIcon';
import CheckIcon from '../../../v2/icons/CheckIcon';
import XIcon from '../../../v2/icons/XIcon';
import PayoutStatusBadge from '../../../v2/PayoutStatusBadge';
import Checkbox from '../../../v2/forms/Checkbox';
import {
  getSignedUrl,
  getDocumentsV2,
} from '../../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../../stores/ToastStore';
import { sluggify } from '../../../../utils/localization/utils';

export class RawCell extends Component {
  render() {
    const output = this.props.data || this.props.default || '';
    return <td className={this.props.className}>{output}</td>;
  }
}

export class DateCell extends Component {
  render() {
    const output = this.props.data || this.props.default || '';
    return <td>{moment(output).format('L')}</td>;
  }
}

class DownloadPDFButton extends Component {
  static propTypes = {
    payout: PropTypes.object.isRequired,
  };

  openSignedUrl = (payout) => async (event) => {
    const { t } = this.props;
    const queryOptions = {
      limit: 1,
      order: {
        field: 'createdAt',
        direction: 'desc',
      },
    };
    event.preventDefault();
    try {
      const { data: documentPayout, errors: documentErrors } =
        await getDocumentsV2([payout._id], null, queryOptions);

      if (documentErrors) {
        showToast(
          t('GET_DOCUMENT_ERROR'),
          t('GET_DOCUMENT_FAILED_WITH_ERROR', {
            error: documentErrors[0].message,
          }),
          'error',
        );
        return;
      }

      const { data, errors: signedUrlErrors } = await getSignedUrl(
        documentPayout?.getDocumentsV2?.documents?.[0]?.key,
      );

      if (signedUrlErrors) {
        showToast(
          t('GET_SIGNED_URL_ERROR'),
          t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
            error: signedUrlErrors[0].message,
          }),
          'error',
        );
        return;
      }

      const url = data?.getSignedUrl?.signedUrl;
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (e) {
      console.error('payouts/renderer: error getting signed url: ', e);
    }
  };

  render() {
    const { payout, t } = this.props;
    return (
      <a
        href={payout.number}
        title={t('DOWNLOAD_PDF')}
        className={getCircleButtonClass({
          color: 'green',
          className: 'button-with-icon',
        })}
        onClick={this.openSignedUrl(payout)}
      >
        <DownloadIcon />
      </a>
    );
  }
}
export default withTranslation()(DownloadPDFButton);
export class CarrierPayoutNumberCell extends Component {
  render() {
    const payout = this.props.data;
    return (
      <td>
        <Link to={'/carrier-payouts/' + payout._id}>{payout.number}</Link>
      </td>
    );
  }
}

export class PayoutNumberCell extends Component {
  render() {
    const payout = this.props.data;
    return (
      <td>
        <Link to={'/payouts/' + payout._id}>{payout.number}</Link>
      </td>
    );
  }
}

export class PayoutStatusCell extends Component {
  render() {
    const payoutStatus = this.props.data;

    return (
      <td>
        <Translation>
          {(t) => (
            <PayoutStatusBadge
              status={payoutStatus}
              label={t(sluggify(payoutStatus))}
            />
          )}
        </Translation>
      </td>
    );
  }
}

export const BooleanCell = ({ data }) => {
  let icon;
  let color;
  if (data) {
    icon = <CheckIcon />;
    color = 'green';
  } else {
    icon = <XIcon />;
    color = 'red';
  }

  return (
    <td>
      <div className={getCircleButtonClass({ color })}>{icon}</div>
    </td>
  );
};

export class MoneyCell extends Component {
  render() {
    const { data: amount, currency } = this.props;
    return <td>{formatMoney(amount, currency)}</td>;
  }
}

export class PayoutHistoryCell extends Component {
  render() {
    let report = '';
    const ev = this.props.data.at(-1);

    if (ev) {
      report = `${humanize(ev.event)} ${moment(ev.timestamp).format(
        'L',
      )} - by ${ev.user || 'Unknown user'}`;
    }

    return (
      <td>
        <p>{report}</p>
      </td>
    );
  }
}

export const ActionsCell = ({
  approveAction,
  declineAction,
  approveColor,
  declineColor,
  disableApprove,
  disableDecline,
}) => {
  const checkColor = approveColor || 'green';
  const xColor = declineColor || 'red';

  return (
    <td>
      <div className="flex justify-between">
        <button
          type="button"
          disabled={disableApprove}
          className={getCircleButtonClass({
            color: checkColor,
            disabled: disableApprove,
          })}
          onClick={!disableApprove ? approveAction : undefined}
        >
          <CheckIcon />
        </button>
        <button
          type="button"
          disabled={disableDecline}
          className={getCircleButtonClass({
            color: xColor,
            disabled: disableDecline,
          })}
          onClick={!disableDecline ? declineAction : undefined}
        >
          <XIcon />
        </button>
      </div>
    </td>
  );
};

export const PayoutCheckBoxCell = ({
  payoutId,
  checked,
  handleToggleCheck,
  disabled,
}) => {
  return (
    <td>
      <Checkbox
        className="cursor-pointer"
        id={payoutId}
        checked={checked}
        onChange={() => handleToggleCheck(payoutId)}
        disabled={disabled}
      />
    </td>
  );
};
